'use client';

import { ServerErrorInfo } from '@/helpers/serverErrorSnackbarHelper';
import { useSnackbar } from '@/hooks/useSnackbar';
import { useEffect, useRef } from 'react';

type Props = {
  error: ServerErrorInfo | null;
};

export function ServerErrorSnackbar({ error }: Props) {
  const { openSnackbar } = useSnackbar();
  const lastErrorRef = useRef<ServerErrorInfo | null>(null);

  useEffect(() => {
    if (!error) return;

    if (!error.message || lastErrorRef.current?.uniqueKey === error.uniqueKey) {
      return;
    }

    lastErrorRef.current = error;
    openSnackbar(error.message, 'error');

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [error?.uniqueKey]);

  return null; // 表示不要な通知専用コンポーネント
}
